import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import AuthForm, { IHandler } from '../components/AuthForm';
import Section from '../components/Section';
import PreFooter from '../components/PreFooter';

import {
  loginWithEmail,
  loginWithFacebook,
  loginWithGoogle,
} from '../services/auth';

const useStyles = makeStyles({
  footer: {
    bottom: 0,
    position: 'fixed',
    width: '100%',
  },
  link: {
    '&:link': {
      textDecoration: 'none',
    },
  },
});

const Login = () => {
  const { footer, link } = useStyles();
  const authRef = useRef<IHandler>(null);
  const [submitting, setSubmitting] = useState(false);
  const componentIsMounted = useRef(true);
  useEffect(() => {
    return () => {
      componentIsMounted.current = false;
    };
  }, []);
  const handleLogin = async (email: string, password: string) => {
    setSubmitting(true);
    const error = await loginWithEmail(email, password);
    if (!componentIsMounted.current) return;
    setSubmitting(false);
    if (error) {
      authRef.current?.setError(error);
    }
  };

  const handleLoginWith = async (provider: string) => {
    let error;
    setSubmitting(true);
    switch (provider) {
      case 'facebook':
        error = await loginWithFacebook();
        break;
      case 'google':
        error = await loginWithGoogle();
        break;
      default:
        break;
    }
    if (!componentIsMounted.current) return;
    setSubmitting(false);
    if (error) {
      authRef.current?.setError(error);
    }
  };

  return (
    <>
      <Container maxWidth='md'>
        <Section display='flex' flexDirection='column' alignItems='center'>
          <AuthForm
            ref={authRef}
            onSubmit={handleLogin}
            onLoginWith={handleLoginWith}
            submitting={submitting}
          />
          <Box mt={3} display='flex'>
            <Typography style={{ marginRight: 8 }}>ยังไม่มีบัญชี?</Typography>
            <Link className={link} to='/register'>
              <Typography color='secondary'>ลงทะเบียนที่นี่</Typography>
            </Link>
          </Box>
        </Section>
      </Container>
      <Box className={footer}>
        <PreFooter />
      </Box>
    </>
  );
};

export default Login;
